<template>
    <v-bottom-navigation :bg-color="'orange-darken-1'" class="bottom-nav" fixed color="white" name="bottom-nav">
      <v-btn to="/home" class="bold-btn" dense :style="{ fontSize: '0.8rem', padding: '6px 12px' }">
        <v-icon :style="{ fontSize: '20px' }">mdi-home-circle-outline</v-icon>
        <span>Inicio</span>
      </v-btn>

      <v-btn to="/marcas-mvgrupo" class="bold-btn" dense :style="{ fontSize: '0.8rem', padding: '6px 12px' }">
        <v-icon :style="{ fontSize: '20px' }">mdi mdi-shopping-outline</v-icon>
        <span>MVExpress</span>
      </v-btn>



      <v-btn to="/top-10" class="bold-btn" dense :style="{ fontSize: '0.8rem', padding: '6px 12px' }">
        <v-icon :style="{ fontSize: '20px' }">mdi-star-outline</v-icon>
        <span>TOP 10</span>
      </v-btn>

      <v-btn to="/user-info" class="bold-btn" dense :style="{ fontSize: '0.8rem', padding: '6px 12px' }">
        <v-icon :style="{ fontSize: '20px' }">mdi-account</v-icon>
        <span>Mi perfil</span>
      </v-btn>
    </v-bottom-navigation>

    <!-- Diálogo del carrito -->
    <v-dialog v-model="cartDialog" max-width="600" scrollable>
      <v-card>
        <v-card-title class="headline" style="background-color: #f1f1f1; padding: 16px;">
          <v-icon left color="primary">mdi-cart</v-icon>
          <span>Tu Carrito</span>
        </v-card-title>

        <v-card-text>
          <v-list-item v-if="cart.length === 0">
            <v-list-item>
              <v-list-item-title>No hay productos en el carrito</v-list-item-title>
            </v-list-item>
          </v-list-item>

          <!-- Mostrar productos si hay en el carrito -->
          <div v-for="(item, index) in cart" :key="index" class="cart-item">
            <v-row no-gutters align="center" class="mb-3">
              <!-- Imagen del producto -->
              <v-col cols="12" sm="2" class="d-flex align-center justify-center mb-2">
                <v-img :src="item.foto" width="50px" height="50px"></v-img>
              </v-col>
              <v-col cols="12" sm="6" class="d-flex flex-column align-center align-sm-start">
                <span class="text-body-2 font-weight-medium">{{ item.nombre }}</span>
                <span class="text-caption text-grey-darken-1">SKU: {{ item.sku }}</span>
                <span class="text-subtitle-2 font-weight-bold text-primary">${{ item.price }}</span>
              </v-col>

              <!-- Cantidad y botones para aumentar/disminuir -->
              <v-col xs="12" sm="6" md="4" lg="3" class="d-flex justify-center justify-sm-end align-center mt-2">
                <v-btn @click="item.quantity--" :disabled="item.quantity <= 1" icon small class="p-0" elevation="0">
                  <v-icon>mdi-minus</v-icon>
                </v-btn>

                <span class="mx-2">CJA {{ item.quantity }}</span>

                <v-btn @click="item.quantity++" icon small class="p-0" elevation="0">
                  <v-icon>mdi-plus</v-icon>
                </v-btn>

                <v-btn @click="removeFromCart(index)" icon small class="p-0 ml-2" elevation="0">
                  <v-icon>mdi-delete-outline</v-icon>
                </v-btn>
              </v-col>
            </v-row>
            <v-divider></v-divider>
          </div>

          <!-- Total del carrito -->
          <div class="d-flex justify-end align-center mt-3">
            <v-chip color="primary" class="text-h6 font-weight-bold">
              Total: ${{ calculateTotal() }}
            </v-chip>
          </div>

          <!-- Sugerencias de productos -->
          <div v-if="suggestedItems.length > 0" class="mt-4">
            <h3 class="subtitle-2 mb-2">Productos que te pueden interesar</h3>
            <v-row>
              <v-col v-for="product in suggestedItems" :key="product.id" cols="12" sm="6" md="4"
                class="d-flex flex-column align-center">
                <v-img :src="product.foto" width="100" height="100" alt="Imagen del producto"></v-img>
                <span class="mt-2">{{ product.nombre }}</span>
                <span class="font-weight-bold">${{ product.price || 'N/A' }}</span>
                <v-btn class="text-none text-subtitle-1" color="white" size="small" variant="tonal"
                  @click="addToCart(product)">
                  <v-img src="https://img.icons8.com/?size=512&id=63650&format=png" width="20px" height="20px"
                    class="mr-2"></v-img>
                </v-btn>
              </v-col>
            </v-row>
          </div>
        </v-card-text>

        <v-card-actions>
          <!-- Botones para cerrar el diálogo o proceder con la compra -->
          <v-btn @click="cartDialog = false" color="secondary" small>Cerrar</v-btn>
          <v-btn @click="checkout" color="primary" small>
            <v-icon>mdi-check-decagram-outline</v-icon> Pagar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>

<script>
export default {
  name: 'BottomNavigation',
  data() {
    return {
      cart: JSON.parse(localStorage.getItem('cart')) || [],
      cartDialog: false,
      suggestedItems: [], // Aquí deberías agregar lógica para sugerir productos
    };
  },
  cartCount() {
    return this.cart.length;
  },
  mounted() {
    window.addEventListener('storage', this.loadCart);
  },
  beforeUnmount() {
    window.removeEventListener('storage', this.loadCart);
  },

  methods: {
    navigateTo(route) {
      this.$router.push({ name: route });
    },
    openCart() {
      this.cartDialog = true;
      this.suggestedProducts();
    },
    addToCart(product) {
      const existingProduct = this.cart.find(item => item.sku === product.sku);
      if (existingProduct) {
        existingProduct.quantity++;
      } else {
        this.cart.push({ ...product, quantity: 1 });
      }
      localStorage.setItem('cart', JSON.stringify(this.cart));
      window.dispatchEvent(new Event('storage')); // Dispara evento para actualizar otras vistas
    },
    removeFromCart(index) {
      this.cart.splice(index, 1);
      localStorage.setItem('cart', JSON.stringify(this.cart));
      window.dispatchEvent(new Event('storage'));
    },
    calculateTotal() {
      return this.cart.reduce((total, item) => total + item.price * item.quantity, 0).toFixed(2);
    },
    checkout() {
      const total = this.calculateTotal();
      this.cart = [];
      this.cartDialog = false;
      this.$router.push({ path: '/metodo-pago', query: { total } });
    },
    suggestedProducts() {
      // Aquí puedes agregar lógica para sugerir productos basados en el carrito o categorías
      // Por ahora, lo dejamos vacío
    }
  }
}
</script>

<style scoped>
.bottom-nav {
  /* 📱 Ajuste CRÍTICO para iPhone/Android con gestos */
  padding-bottom: env(safe-area-inset-bottom) !important;
  height: calc(56px + env(safe-area-inset-bottom)) !important;
  z-index: 1005 !important;
}
.bold-btn span {
  font-weight: bold;
}

.bold-btn v-icon {
  font-weight: bold;
}

@media (max-width: 600px) {
  .bold-btn {
    font-size: 0.8rem;
    padding: 6px 12px;
  }

  .bold-btn v-icon {
    font-size: 10px;
  }
}
</style>
